import React from "react";
import clsx from "clsx";

import { ReactComponent as EnvironmentIcon } from "../../../../assets/images/Help/icon_section_environment.svg";
import common from "../common.module.scss";

import RecommendedEnvironmentPanel from "./RecommendedEnvironmentPanel";
import PlaybackCheckPanel from "./PlaybackCheckPanel";
import styles from "./HelpEnvironmentSection.module.scss";

const HelpEnvironmentSection = () => {
  return (
    <section id="environment" className={common.section}>
      <p className={common.heading}>
        <span className={common.group}>
          <EnvironmentIcon />
          ご利用環境の確認
        </span>
      </p>
      <p className={common.description}>
        こちらでは、サービスご利用時の「推奨環境・基本的な動作」をご確認いただけます。
        <br />
        実際に授業でご利用になる環境／端末にてご確認ください。
      </p>
      <div className={clsx(common.content, styles.content)}>
        <RecommendedEnvironmentPanel />
        <PlaybackCheckPanel />
      </div>
    </section>
  );
};

export default HelpEnvironmentSection;
